export default "__VITE_ASSET__BmUG5Rfr__"